<h2 mat-dialog-title class="dialog-title">
  Session Logs
</h2>

<mat-dialog-content class="dialog-content">

  <!-- HEADER -->
  <div class="session-header">

    <div class="chip">
      <span class="label">Session</span>
      <span class="value mono">{{ data.id }}</span>
    </div>

    <div class="chip" *ngIf="data.target_user_name">
      <span class="label">User Name</span>
      <span class="value">{{ data.target_user_name }}</span>
    </div>

    <div class="chip" *ngIf="data.target_user_email">
      <span class="label">User Email</span>
      <span class="value">{{ data.target_user_email }}</span>
    </div>

    <div class="chip" *ngIf="data.admin_name">
      <span class="label">Agent Name</span>
      <span class="value">{{ data.admin_name }}</span>
    </div>

    <div class="chip" *ngIf="data.target_user_email">
      <span class="label">Agent Email</span>
      <span class="value">{{ data.admin_email }}</span>
    </div>

    <div class="chip">
      <span class="label">Logs</span>
      <span class="value">{{ total }}</span>
    </div>

  </div>

  <!-- LOADING -->
  <div *ngIf="logsLoader" class="loading">
    Loading logs...
  </div>

  <!-- TABLE -->
  <div class="table-wrapper" [hidden]="logs?.length === 0">

    <table class="log-table">

      <thead>
        <tr>
          <th>Time</th>
          <th>Method</th>
          <th>Endpoint</th>
          <th>Status</th>
        </tr>
      </thead>

      <tbody>

        <tr *ngFor="let log of logs">

          <td class="mono">
            {{ log.created_at | date:'short' }}
          </td>

          <td>
            <span class="method-chip" [ngClass]="log.method">
              {{ log.method }}
            </span>
          </td>

          <td class="mono endpoint">
            {{ log.endpoint }}
          </td>

          <td>
            <span class="status-chip"
              [ngClass]="log.response_status >= 200 && log.response_status < 300 ? 'success' : 'error'">
              {{ log.response_status }}
            </span>
          </td>

        </tr>

      </tbody>

    </table>

    <mat-paginator [length]="total" [pageSize]="limit" [pageSizeOptions]="[50, 100, 250]" (page)="onPage($event)">
    </mat-paginator>

  </div>

  <!-- EMPTY -->
  <div *ngIf="!logsLoader && logs.length === 0" class="empty-state">
    No logs found for this session
  </div>

</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
  <button mat-stroked-button mat-dialog-close>
    Close
  </button>
</mat-dialog-actions>